export const styles = {
  global: {
    body: {
      bg: "gray.50",
      overflowY: "scroll",
    },
  },
};
